import { optionTypeLeave } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";
import colors from "theme/theme-light/colors";
export const DayLeaveType = {
  HOLIDAY: "Ngày lễ",
};

export const transformDataTimeChecking = (data: Record<string, any>) => {
  const result: Record<string, any[]> = {};

  Object.keys(data).forEach((date) => {
    const dayData = data[date];
    result[date] = [
      {
        type: "timeChecking",
        payload: {
          checkInTime: dayData.checkInTime,
          checkOutTime: dayData.checkOutTime,
        },
      },
      {
        type: "lackOfTimeChecking",
        payload: {
          day: date,
          lateDuration: dayData.lateDuration,
          earlyLeaveDuration: dayData.earlyLeaveDuration,
          earlyLeaveRequest: dayData.earlyLeaveRequest,
          lateRequest: dayData.lateRequest,
          status: dayData.regArriveLateApproveStatus,
          regEarlyApproveStatus: dayData.regEarlyApproveStatus,
          regLateApproveStatus: dayData.regLateApproveStatus,
          lateSecondRequest: dayData.lateSecondRequest,
          regArriveLateApproveStatusSecond:
            dayData.regArriveLateApproveStatusSecond,
          earlyLeaveSecondRequest: dayData.earlyLeaveSecondRequest,
          regArriveEarlyApproveStatusSecond:
            dayData.regArriveEarlyApproveStatusSecond,
        },
      },
      {
        type: "dayLeave",
        payload:
          dayData.dayDescription === DayLeaveType.HOLIDAY
            ? [
                {
                  leaveCategory: DayLeaveType.HOLIDAY,
                  leaveType: optionTypeLeave.FULL_DAY.value,
                  hexColor: colors.colorsBase.violet_0,
                },
              ]
            : dayData.dayOffList,
      },
      {
        type: "noData",
        payload: {
          day: date,
          explainAllow: dayData.explainAllow,
          explainStatus: dayData.explainStatus,
          id: dayData.explainId,
          explainEditable: dayData.explainEditable,
          noData:
            (dayData.dayOffList ?? []).length === 0 &&
            dayData.dayDescription !== DayLeaveType.HOLIDAY &&
            !dayData.checkInTime &&
            !dayData.checkOutTime &&
            !dayData.lateDuration &&
            !dayData.earlyLeaveDuration,
        },
      },
    ];
  });

  return result;
};

export const ErrorMessage = {
  NOT_FOUND: "Không tìm thấy bản ghi",
  ERR_403: "Bạn không có quyền truy cập",
};
